/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchManufacturersDictionaryResponse } from './search-manufacturers-dictionary-response';


export interface SearchManufacturersDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchManufacturersDictionaryResponse> | null;
}

